import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select,
    Popconfirm,
    Form,
    Radio,
    Switch,
    Cascader,
    TreeSelect,
    notification,
    message, Table, Tag, Statistic, Alert, Calendar, Modal
} from 'antd';
import { EditOutlined, DeleteOutlined, WechatOutlined } from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
import cookie from "react-cookies";
const { Title,Text } = Typography;
const { Content } = Layout;
const { Meta } = Card;

const DateList = (start) => {
    const [value, setValue] = useState(() => moment());
    const [selectedValue, setSelectedValue] = useState(() => moment());
    const onSelect = (newValue) => {
        setValue(newValue);
        setSelectedValue(newValue);
    };
    const onPanelChange = (newValue) => {
        setValue(newValue);
    };
    const getListData = (value,list) => {
        let listData;
        const date = value.format('YYYY-MM-DD');
        for (let i = 0; i < list.length; i++) {
            if(date == list[i].clientprice_date){
                listData = list[i].clientprice_value;
            }
        }
        return listData || '';
    };
    const dateCellRender = (value) => {
        const listData = getListData(value,start.date);
        return (
            <>
                {
                    listData
                    ?

                        <Tag color="#108ee9">
                            {listData}元/吨
                        </Tag>
                        :
                        ''
                }
            </>
        );
    };
    const onFinish = (values) => {

        function queryParse(query){
            let queryText = "";
            for(let key in query){
                queryText += `${key}=${query[key]}&`;
            }
            return queryText.slice(0,-1);
        }
        var list = {};
        list.clientprice_value = values.value ? values.value : 0;
        list.clientprice_date = selectedValue.format('YYYY-MM-DD');
        if(start.id){
            list.clientprice_client = start.id;
            list.clientprice_stock = start.type
            fetch("https://pd.pokemonbye.com:8084/api/insertsellclientprice",
                {
                    method:'post',
                    body:queryParse(list),
                    headers:{
                        'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        openNotification();
                        window.location.reload();
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
    };
    return (
        <>
            <Card title=" " bordered={false}>
                <Space>
                    <Form
                        labelCol={{
                            span: 10,
                        }}
                        wrapperCol={{
                            span: 20,
                        }}
                        layout="horizontal"
                        onFinish={onFinish}
                    >
                        <Form.Item label="当前选择日期" name="date">
                            {selectedValue.format('YYYY-MM-DD')}
                        </Form.Item>
                        <Form.Item label="设置日期价格" name="value"
                                   rules={[
                                       {
                                           required: true,
                                           message: '请输入金额!',
                                       },
                                   ]}>
                            <InputNumber prefix="￥" addonAfter="元"/>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                offset: 4,
                                span: 2,
                            }}
                        >
                            <Button type="primary" htmlType="submit">设置</Button>
                        </Form.Item>
                    </Form>
                </Space>
            </Card>
            <Calendar onSelect={onSelect} onPanelChange={onPanelChange} dateCellRender={dateCellRender} validRange={[start.start,moment()]}/>
        </>
    );
};
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '添加成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};
const info = () => {
    message.info('This is a normal message');
};
const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '金额（元）',
        dataIndex: 'fund_value',
        key: 'fund_value',
    },
    {
        title: '状态',
        dataIndex: 'name',
        key: 'name',
        render: (_, { fund_type }) => (
            <>
                {fund_type == 1
                    ?
                    <Tag color='success'>
                        增加
                    </Tag>
                    :
                    <Tag color='error'>
                        减少
                    </Tag>
                }
            </>
        ),
    },
    {
        title: '备注',
        dataIndex: 'fund_intro',
        key: 'fund_intro',
    },
    {
        title: '时间',
        dataIndex: 'fund_pubtime',
        key: 'fund_pubtime',
    }
];
const columnslist = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '单价（元/吨）',
        dataIndex: 'clientprice_value',
        key: 'clientprice_value',
    },
    {
        title: '生效时间',
        dataIndex: 'clientprice_date',
        key: 'clientprice_date',
    }
];
const Load = (that) => {
    var id = that.state.id
    var type = that.state.type
    const start = that.state.start.format('YYYY-MM-DD')
    if(id) {
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientpricebyclienttype?client=" + id + "&type=1" + "&stock=" + type)
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].key = i + 1;
                        }

                        that.setState({
                            isLoaded: true,
                            sum: array[0],
                            list: array
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    that.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientnum?id=" + id)
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        console.log(array[0])

                        that.setState({
                            isLoaded: true,
                            name: array[0]
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    that.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/getsellstockbyid?id=" + type)
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        console.log(array[0])

                        that.setState({
                            isLoaded: true,
                            stock: array[0]
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    that.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientpricedatebyidtype?start="+start+"&end="+moment().format('YYYY-MM-DD')+"&id=" + id+"&type=" + type)
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){

                        that.setState({
                            isLoaded: true,
                            date: array
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    that.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }
}
const App = (value) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [content, setContent] = useState('查询中');
    const [content2, setContent2] = useState('');
    const showModal = () => {
        setIsModalOpen(true);
        setTimeout(() => {
        }, 1000);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <Button onClick={showModal}>
                历史
            </Button>
            <Modal title="价格历史" open={isModalOpen}
                   footer={[
                       <Button key="back" onClick={handleCancel}>
                           关闭
                       </Button>
                   ]}>

                <Table bordered={true} columns={columnslist} dataSource={value.id}/>
            </Modal>
        </>
    );
};
class PageBusRecordPrice extends Component{

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const type = params.get("type");
        let userId = cookie.load('userId');
        let day = moment().format('DD')/*
        let month = moment().subtract(1,'months').format('YYYY-MM')
        if(day<26){

            month = moment().subtract(2,'months').format('YYYY-MM')
        }*/
        let month = moment().subtract(2,'months').format('YYYY-MM')
        this.state = {
            title: "客户价格",
            county: [],
            id: id,
            type: type,
            userId: userId,
            sum: 0,
            list: [],
            start: moment(month+'-01'),
            date:[],
            name:0,
            stock:0
        };
    }

    componentDidMount() {
        Load(this)
    }
    formRef = React.createRef();
    render() {
        const handleChange = (value) => {
            this.setState({
                type: value
            });
            Load(this)
        };
        const onFinish = (values) => {

            function queryParse(query){
                let queryText = "";
                for(let key in query){
                    queryText += `${key}=${query[key]}&`;
                }
                return queryText.slice(0,-1);
            }
            var list = {};
            list.clientprice_value = values.value ? values.value : 0;
            if(this.state.id){
                list.clientprice_client = this.state.id;
                list.clientprice_stock = this.state.type;
                list.clientprice_type = 1;
                list.clientprice_date = moment().add(1, "days").format('YYYY-MM-DD');
                fetch("https://pd.pokemonbye.com:8084/api/insertsellclientprice",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            openNotification();
                            window.location.reload();
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Row>
                                    <Col span={4}>
                                    </Col>
                                    <Col span={4}>
                                        <Card>{this.state.name.name}
                                                    <Statistic
                                                        title={this.state.stock.stockname}
                                                        value={this.state.sum.clientprice_value}
                                                        precision={2}
                                                        valueStyle={{
                                                            color: '#000000',
                                                        }}
                                                        suffix="元"
                                                    />
                                        </Card>
                                    </Col>
                                    <Col span={16}>
                                        <Form
                                            labelCol={{
                                                span: 4,
                                            }}
                                            wrapperCol={{
                                                span: 10,
                                            }}
                                            layout="horizontal"
                                            size="Large"
                                            onFinish={onFinish}
                                            ref={this.formRef}
                                        >
                                            <Form.Item label="设置客户价" name="value"
                                                       rules={[
                                                           {
                                                               required: true,
                                                               message: '请输入金额!',
                                                           },
                                                       ]}>
                                                <InputNumber prefix="￥" addonAfter="元"/>
                                            </Form.Item>
                                            <Form.Item
                                                wrapperCol={{
                                                    offset: 4,
                                                    span: 16,
                                                }}
                                            >
                                                <Space>
                                                    <Button type="primary" htmlType="submit">{this.state.id?'设置':'新建'}</Button>
                                                    <App id={this.state.list}></App>
                                                </Space>
                                            </Form.Item>
                                        </Form>
                                    </Col>
                                </Row>
                                <br/>
                                <DateList start={this.state.start} date={this.state.date} id={this.state.id} type={this.state.type}/>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageBusRecordPrice;


